import { List, ListItem, Popover, Stack, Typography } from "@mui/material";

interface IToSignPaperChip {
  open: boolean;
  anchorEl: Element | null;
  onClose: () => void;
}

export const ToSignPaperChip = ({ open, anchorEl, onClose }: IToSignPaperChip) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: -16,
        horizontal: "center",
      }}
      slotProps={{ paper: { sx: { maxWidth: 400 } } }}
    >
      <Stack sx={{ padding: 3, paddingLeft: 5 }}>
        <List sx={{ listStyleType: "disc" }}>
          <ListItem sx={{ display: "list-item", pl: 0.5, pb: 0 }}>
            <Typography>
              Pour <b>passer ce CE en “Signé”</b>, téléchargez-le et imprimez-le en cliquant sur le bouton “Imprimante”.
            </Typography>
          </ListItem>
          <ListItem sx={{ display: "list-item", pl: 0.5, pt: 0 }}>
            <Typography>
              Une fois le document signé par toutes les parties prenantes, importez-le de nouveau depuis cette carte en
              cliquant sur le bouton "Flèche vers le haut".
            </Typography>
          </ListItem>
        </List>
      </Stack>
    </Popover>
  );
};
